const API_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

const DICOM_ONLY_WEB_UPLOADER_VALID_MIMETYPES = [
  'application/zip',
  'application/gzip',
  'application/dicom',
  'image/jpeg',
  'image/png',
  'image/tiff',
  'image/tif',
  'application/pdf',
];

const STUDY_WEB_UPLOADER_PREPARATION_TIME_PERCENTAGE = 4.5; // LEGACY INFO: Calculated in https://docs.google.com/spreadsheets/d/1Qo9wu5P7Bv-oLrhxCriQgetDL26Cl9uc_IXI0laiORY/edit#gid=2091234701 in column 'V'
const STUDY_WEB_UPLOADER_UPLOAD_TIME_PERCENTAGE = 100 - STUDY_WEB_UPLOADER_PREPARATION_TIME_PERCENTAGE;
const COMPRESSED_FILE_EXTENSIONS = ['zip', 'gzip'];

// Each uploading stage:
// 1. uploading, 2. importing + 3. pseudonymizing + 4. finishing -> 2-4 all together known as 'importing stage',
// takes equal part from the 100, depending on the pseudonymizing existence(~100/3 or 100/4)
const WEB_UPLOADER_STAGE_UPLOADING_WITH_PSEUDONYMIZING = 25;
const WEB_UPLOADER_STAGE_UPLOADING_WITHOUT_PSEUDONYMIZING = 33;
const WEB_UPLOADER_STAGE_IMPORTING_WITH_PSEUDONYMIZING = 74;
const WEB_UPLOADER_STAGE_STANDALONE_IMPORTING_WITH_PSEUDONYMIZING = 50;
const WEB_UPLOADER_STAGE_IMPORTING_WITHOUT_PSEUDONYMIZING = 66;
const WEB_UPLOADER_EMPIRICAL_EVIDENCE_TIMEOUT_NUMBER = 500; // in milliseconds


const TOASTR_INTERVAL_FROM_CLEARING_UNTIL_FUNCTIONAL_STATE = 500;

const PERSISTENT_TOASTR_SETTINGS = {
  toastClass: 'toast cursor-auto',
  disableTimeOut: true,
  extendedTimeOut: 0,
  easeTime: 0,
  timeOut: 0,
};

const SOCKET_CHANNELS = {
  webupload: 'webupload.{uploadKey}',
};

const DEADLETTER_DOWNLOAD_ALLOWED_INITIAL_DATE = new Date('2023-03-01T00:00:00.000Z');

const THUMBNAIL_SIZE = 1024;
const ANSWER_YES_OR_NO = {
  YES: 'Yes',
  NO: 'No',
};

const ENTRY_SOURCE_TYPES = {
  EVENT: 'event',
  METADATA: 'metadata',
};

const PARSER_MIME_TYPES = {
  HTML: 'text/html',
};

export {
  API_METHODS,
  COMPRESSED_FILE_EXTENSIONS,
  DICOM_ONLY_WEB_UPLOADER_VALID_MIMETYPES,
  PERSISTENT_TOASTR_SETTINGS,
  SOCKET_CHANNELS,
  STUDY_WEB_UPLOADER_UPLOAD_TIME_PERCENTAGE,
  STUDY_WEB_UPLOADER_PREPARATION_TIME_PERCENTAGE,
  DEADLETTER_DOWNLOAD_ALLOWED_INITIAL_DATE,
  TOASTR_INTERVAL_FROM_CLEARING_UNTIL_FUNCTIONAL_STATE,
  THUMBNAIL_SIZE,
  ANSWER_YES_OR_NO,
  ENTRY_SOURCE_TYPES,
  WEB_UPLOADER_STAGE_UPLOADING_WITH_PSEUDONYMIZING,
  WEB_UPLOADER_STAGE_UPLOADING_WITHOUT_PSEUDONYMIZING,
  WEB_UPLOADER_STAGE_IMPORTING_WITH_PSEUDONYMIZING,
  WEB_UPLOADER_STAGE_IMPORTING_WITHOUT_PSEUDONYMIZING,
  WEB_UPLOADER_STAGE_STANDALONE_IMPORTING_WITH_PSEUDONYMIZING,
  WEB_UPLOADER_EMPIRICAL_EVIDENCE_TIMEOUT_NUMBER,
  PARSER_MIME_TYPES,
};
